import PropTypes from 'prop-types'
import {
  productFromNetworkShape
} from './products'

export const cartItemShape = {
  sfid: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  product: PropTypes.shape(productFromNetworkShape)
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/shop/src/js/shapes/cart.js